// extracted by mini-css-extract-plugin
export default {"container":"YN-z","dimension":"ZN-z","dimensionLabels":"_N-z"};